"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbTableColumn = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var TbTable_1 = require("./TbTable");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        tableCell: {
            padding: '8px 4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:first-child': {
                paddingLeft: 32,
                fontFamily: 'Montserrat-Bold',
                fontSize: 16,
                lineHeigth: 1.25
            }
        },
        tableButton: {
            display: 'inline-block',
            padding: '8px 22px',
            textAlign: 'center',
            verticalAlign: 'middle',
            height: 36,
            minWidth: 80,
            outline: 'none',
            MozAppearance: 'none',
            fontFamily: 'Montserrat!important',
            fontSize: 16,
            lineHeight: 1,
            boxSizing: 'border-box',
            borderRadius: 5,
            border: '1px solid',
            backgroundColor: '#fff',
            color: function (_a) {
                var color = _a.color;
                return color;
            },
            borderColor: function (_a) {
                var color = _a.color;
                return color;
            },
            '&.MuiButtonBase-root.Mui-disabled': {
                color: 'rgb(214 214 214)',
                borderColor: 'rgb(214 214 214)'
            }
        },
        tooltip: {
            marginTop: -7,
            '& span': {
                fontSize: 12,
                lineHeight: '1.5 !important',
                color: 'white !important'
            }
        }
    });
});
var TbTableColumn = function (_a) {
    var _b;
    var column = _a.column, row = _a.row, color = _a.color, valueMapper = _a.valueMapper, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
    var classes = useStyles({ color: color });
    var _c = valueMapper({ row: row, valueKey: column.key, classNameButton: classes.tableButton }), value = _c.value, tooltip = _c.tooltip, tooltipValue = _c.tooltipValue;
    return (tooltip
        ? react_1.default.createElement(core_1.Tooltip, { "aria-label": "Tooltip Row " + rowIndex + " Column " + column.headerName, classes: { tooltip: classes.tooltip }, title: (_b = tooltipValue !== null && tooltipValue !== void 0 ? tooltipValue : value) !== null && _b !== void 0 ? _b : '-', placement: 'bottom-start' },
            react_1.default.createElement(core_1.TableCell, { className: classes.tableCell, style: (0, TbTable_1.getColumnStyle)(column) }, value !== null && value !== void 0 ? value : '-'))
        : react_1.default.createElement(core_1.TableCell, { key: "row-" + rowIndex + "_column-" + columnIndex, className: classes.tableCell, style: (0, TbTable_1.getColumnStyle)(column) }, value !== null && value !== void 0 ? value : '-'));
};
exports.TbTableColumn = TbTableColumn;
//# sourceMappingURL=TbTableColumn.js.map